"use client";

import { ListingsGridCard } from "@/components";
import { type Listing } from "@/services/api";
import React from "react";

interface ListingsGridProps {
  listings: Listing[];
  openLoginRegistrationModal?: () => void;
  isGridView?: boolean;
}

const ListingsGrid: React.FC<ListingsGridProps> = ({
  listings,
  isGridView = true,
}) => {
  if (!listings || listings.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-600 font-raleway">
          No listings found. Try adjusting your filters.
        </p>
      </div>
    );
  }

  return (
    <div>
      <div className={`grid gap-6 mb-8 ${isGridView
        ? "grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4"
        : "grid-cols-1"
        }`}>
        {listings.map((listing, index) => (
          <ListingsGridCard
            key={listing._id}
            listing={listing}
            showDealLabel={true}
            position={index + 1}
          />
        ))}
      </div>
    </div>
  );
};

export default ListingsGrid;
